export default {
  articles: {
    breadcrumbHome: "Home",
    breadcrumbGuides: "Guides",
    author: "USFansLink Editorial Team",
    readingTime: "7 min read",
    lastUpdated: "Last Updated: August 2026",
    notFound: "Guide not found",
    tocTitle: "Table of Contents",
    s1Title: "Why This Topic Matters",
    s1Body:
      "Every part of the USFans research process, from product lists to shipping details, shapes the decisions you make before you buy. When you understand how this piece fits into the bigger picture, you can compare options with more confidence and avoid surprises later.",
    s2Title: "How to Get Started",
    s2Body:
      "Begin with the categories or columns that matter most to you, then narrow things down step by step. A simple, repeatable approach — review, compare, then confirm details — keeps your research organized and makes it easier to spot the information you actually need.",
    s3Title: "Things to Keep in Mind",
    s3Body:
      "Details can change, and not every option works the same way. Double-check the most recent notes, confirm shipping and payment information, and stay cautious with anything that looks unusual. Taking a few extra minutes up front usually saves time and trouble later.",
    faqTitle: "Frequently Asked Questions",
    faq: [
      {
        q: "Is this guide kept up to date?",
        a: "We review and refresh our guides regularly, but details like shipping costs and offers can change quickly, so always confirm the latest information on the store before you buy.",
      },
      {
        q: "Do I need an account to use this information?",
        a: "No, most of these guides and resources are free to read. You may need to sign in to complete a purchase on the main store.",
      },
      {
        q: "Where can I find more USFans resources?",
        a: "Browse the related guides linked on this page or head back to the USFansLink homepage to explore the full set of resources.",
      },
    ],
    relatedTitle: "Related USFans Resources",
    relatedIntro: "Keep exploring with these related guides and resources.",
    relatedHome: "Back to the USFansLink homepage",
    relatedGuide: "Complete USFans Spreadsheet Guide",
    conclusionTitle: "Continue Your USFans Research",
    conclusionBody:
      "Use what you have learned here to continue your research with more confidence, and explore the organized categories and guides whenever you are ready.",
    cta: "Explore USFans Spreadsheet",
    backHome: "Back to Homepage",
    disclaimer:
      "This guide is an independent informational resource and is not affiliated with or endorsed by USFans unless explicitly stated.",
    list: {
      "usfans-spreadsheet-list": {
        title: "USFans Spreadsheet Product List: How to Browse & Compare",
        excerpt:
          "The USFans spreadsheet product list brings items, categories and sellers together in one view. Learn how to browse it, compare options and narrow down products before you click through to the store.",
        tag: "Product Guide",
      },
      "usfans-seller-spreadsheet": {
        title: "USFans Seller Spreadsheet: Researching Sellers the Smart Way",
        excerpt:
          "Seller information can make or break a purchase decision. This guide explains how the seller spreadsheet helps you review track records, compare options and spot the sellers worth your time.",
        tag: "Seller Guide",
      },
      "how-to-use-usfans-spreadsheet": {
        title: "How to Use the USFans Spreadsheet: A Step-by-Step Guide",
        excerpt:
          "New to the USFans spreadsheet? This step-by-step guide walks through categories, filters and columns so you can move from a blank screen to a shortlist of products without the guesswork.",
        tag: "Beginner Guide",
      },
      "usfans-product-research": {
        title: "USFans Product Research Guide: Find What You Need Faster",
        excerpt:
          "Good product research saves time and money. Learn a simple workflow for comparing items, checking details and building a shortlist before you commit to a purchase.",
        tag: "Research Guide",
      },
      "usfans-seller-research": {
        title: "USFans Seller Research Guide: Spot Reliable Sellers",
        excerpt:
          "A careful seller check reduces risk before you buy. This guide covers what to look for in a seller's track record, reviews and shipping details, and how to flag anything suspicious.",
        tag: "Research Guide",
      },
      "usfans-shipping-guide": {
        title: "USFans Shipping Guide: Options, Costs & Delivery",
        excerpt:
          "Shipping options and costs vary widely by seller and destination. This guide explains the common methods, what affects delivery time and how to confirm the final cost before ordering.",
        tag: "Shipping Guide",
      },
      "usfans-coupon-guide": {
        title: "USFans Coupon Guide: Find & Apply Current Offers",
        excerpt:
          "Coupons come and go, and not every code works for every order. Learn where offers appear, how to apply them and what to check before checkout to avoid a wasted code.",
        tag: "Savings Guide",
      },
      "usfans-discount-code-guide": {
        title: "USFans Discount Code Guide: Where Deals Appear",
        excerpt:
          "Discount codes can lower your total, but only when they match your order. This guide explains where codes appear, how to test them and the common reasons a code might not apply.",
        tag: "Savings Guide",
      },
      "usfans-warehouse-guide": {
        title: "USFans Warehouse Guide: Storage & Delivery Explained",
        excerpt:
          "Warehouse and storage processes affect how quickly your order ships. Learn how storage works, what it means for delivery timing and what to check in the warehouse notes.",
        tag: "Logistics Guide",
      },
      "usfans-qc-guide": {
        title: "USFans QC Guide: How to Review Quality Before You Buy",
        excerpt:
          "Quality control photos and checklists help you catch issues before they ship. This guide explains what to look for, how to read QC photos and how to flag concerns early.",
        tag: "Quality Guide",
      },
    },
  },
};